///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import InputMask from "react-input-mask";

import CalendarIcon from "../icons/CalendarIcon";
import { division, dateFormat } from "../../helpers/types";

const CustomDatePicker = ({
  value,
  label,
  onChange,
  disabled,
  error,
  validationMessage,
  onFocus,
  isClearable,
  ...rest
}) => {
  let _calendar = null;
  const [shrink, toggleShrink] = useState(false);
  const [focus, toggleFocus] = useState(false);
  const { user } = useSelector(state => state.user);

  const handleClick = () => {
    _calendar.setOpen(true);
    toggleFocus(true);
  };

  const handleChangeRaw = (e) => {
    if (!(e?.target?.value ?? "").replace(/\D/g, "").length) onChange("");
  };

  return (
    <div className="date-picker">
      <DatePicker
        autoComplete="off"
        calendarClassName="coyote"
        className={(focus ? "focus " : "") + (error ? "error " : "")}
        dateFormat={
          user.division === division.coy ? dateFormat.MMddyy : dateFormat.ddMMyy
        }
        disabled={disabled}
        formatWeekDay={dayOfWeekLabel =>
          dayOfWeekLabel.substring(0, 3).toUpperCase()
        }
        onCalendarClose={() => toggleShrink(false)}
        onCalendarOpen={() => toggleShrink(true)}
        onChange={date => onChange(date ? date.toISOString() : "")}
        onChangeRaw={handleChangeRaw}
        onFocus={onFocus}
        ref={c => (_calendar = c)}
        selected={value && new Date(value)}
        showPopperArrow={false}
        strictParsing
        showYearDropdown={true}
        showMonthDropdown={true}
        yearDropdownItemNumber={3}
        customInput={<InputMask type="text" mask="99/99/99" />}
        isClearable={isClearable}
        {...rest}
      />
      <label
        className={
          "block date-picker-label " +
          (shrink || value ? "shrink " : "") +
          (disabled ? "disabled " : "") +
          (error ? "error " : "")
        }
      >
        {label}
      </label>
      <button
        className="datepicker-icon"
        disabled={disabled}
        onBlur={() => toggleFocus(false)}
        onClick={handleClick}
        onFocus={onFocus}
        tabIndex={-1}
      >
        <CalendarIcon
          height="16"
          width="16"
          fill={disabled ? "#c9cacc" : "#343434"}
        />
      </button>
      {error && validationMessage && (
        <span className="validation-message">{validationMessage}</span>
      )}
    </div>
  );
};

export default CustomDatePicker;
